/// <amd-module name="Wit/UI/DataSources/CollectionFieldsDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { WorkItemField, FieldType } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { FieldType as FieldTypeEnum } from "Wit/Common/Generated/Constants";

const FieldsDataProviderId = "ms.vss-work-web.fields-data-provider";

/** Description of field object coming from server. Not exposed for consumption */
interface FieldInternal {
    referenceName: string;
    type: FieldTypeEnum;
}

interface FieldsDataResponse {
    data: FieldInternal[];
}

/**
 * Issues a collection-scoped fields request, with caching enabled by default.
 */
export async function getFieldTypesAsync(pageContext: IVssPageContext, reuseCachedResult: boolean = true): Promise<{ [key: string]: FieldType } | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return mapFieldsToTypes(await contributionService.getDataAsync<FieldsDataResponse>(FieldsDataProviderId, {}, reuseCachedResult));
}

/** Associates field names to types for simple lookup. */
function mapFieldsToTypes(fieldsResponse: FieldsDataResponse | undefined): { [key: string]: FieldType } {
    const fieldTypesMap = mapFieldTypes(); // Provides mapping to commonly used REST types format.

    const fieldSet: { [key: string]: FieldType } = {};
    if (fieldsResponse && fieldsResponse.data) {
        for (let i = 0; i < fieldsResponse.data.length; i++) {
            const field = fieldsResponse.data[i];
            fieldSet[field.referenceName] = fieldTypesMap[field.type];
        }
    }
    return fieldSet;
}

/** Relate field index Ids from WIT Common Constants Type to WIT REST FieldType  (They are not mapped to the same values, but the ones which exist use the same names) */
function mapFieldTypes(): { [key: number]: FieldType } {
    const map = [];
    map[FieldTypeEnum.Boolean] = FieldType.Boolean;
    map[FieldTypeEnum.DateTime] = FieldType.DateTime;
    map[FieldTypeEnum.Double] = FieldType.Double;
    map[FieldTypeEnum.Guid] = FieldType.Guid;
    map[FieldTypeEnum.History] = FieldType.History;
    map[FieldTypeEnum.Html] = FieldType.Html;
    map[FieldTypeEnum.Integer] = FieldType.Integer;
    map[FieldTypeEnum.PicklistInteger] = FieldType.PicklistInteger;
    //Note: PicklistDouble is undefined from the legacy field types
    map[FieldTypeEnum.PicklistString] = FieldType.PicklistString;
    map[FieldTypeEnum.PlainText] = FieldType.PlainText;
    map[FieldTypeEnum.String] = FieldType.String;
    map[FieldTypeEnum.TreePath] = FieldType.TreePath;
    return map;
}
